import { ChangeEvent, MouseEvent, memo, KeyboardEvent } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

interface SearchInputProps {
  value: string;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear: (event: MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInput = memo(({ value, placeholder, onChange, onClear, onKeyDown }: SearchInputProps) => {
  return (
    <TextField
      onKeyDown={onKeyDown}
      autoComplete='off'
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            {value ? (
              <IconButton onClick={onClear} size='large' disableRipple sx={{ p: 0 }} aria-label='clear-search'>
                <ClearIcon fontSize='small' />
              </IconButton>
            ) : (
              <SearchIcon fontSize='small' color='disabled' aria-label='search' />
            )}
          </InputAdornment>
        ),
      }}
      value={value}
      onChange={onChange}
      fullWidth
      sx={{
        padding: 1,
      }}
    />
  );
});
